<script>
import { useMediaQuery } from '@vueuse/core';

export default {
  setup() {
    const isLargeScreen = useMediaQuery('(min-width: 1024px)');

    return {
      isLargeScreen
    };
  }
};
</script>

<template>
  <div class="flex justify-between pb-6" v-if="isLargeScreen">
    <div class="text-6 font-bold uppercase w-196">
      {{ __('product_title') }}
    </div>
    <div class="text-6 font-bold uppercase w-16%">{{ __('price_title') }}</div>
    <div class="text-6 font-bold text-center uppercase w-76">
      {{ __('quantity_title') }}
    </div>
    <div class="text-6 font-bold text-right uppercase flex-grow">
      {{ __('subtotal_title') }}
    </div>
    <div class="w-20"></div>
  </div>

  <div
    class="divide-y-1px divide-gray-400 border-t-1px border-b-1px border-gray-400"
  >
    <slot></slot>
  </div>
</template>
